import { createContext, useContext, type ReactNode } from 'react';
import { resolveClientPreselect, type ClientPreselect } from '@lib/client-preselect';

/**
 * The campaign the pages ask the API for, as ONE value provided by the shell, instead of a
 * `const CAMPAIGN = '26fobt'` copied into every page. The shell resolves it once per location
 * from the Hub `?client=` read (client-preselect.ts); the pages only consume it.
 *
 * The default context value is the station default, so a page rendered outside the shell (tests,
 * storybook-style previews) behaves exactly as it did with the constant.
 */
const DEFAULT_PRESELECT: ClientPreselect = resolveClientPreselect([]);

const CampaignContext = createContext<ClientPreselect>(DEFAULT_PRESELECT);

export function CampaignProvider({ value, children }: { value: ClientPreselect; children: ReactNode }) {
  return <CampaignContext.Provider value={value}>{children}</CampaignContext.Provider>;
}

/** The current campaign selection: `campaign` (slug), `client`, `source`, and any `notice` to show. */
export function useCampaign(): ClientPreselect {
  return useContext(CampaignContext);
}
